"use client"
import React from 'react'
import Navbar from '../../components/agent/common/Navbar'
import MainMarketing from '../../components/agent/marketing/MainMarketing'

const AgentMarketing = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
        <MainMarketing/>
      </main>
    </div>
  )
}

export default AgentMarketing